export default {
  computed: {
    id () {
      const item = this.item
      if (item.discount_id) {
        return this._('DIS')
      }
      if (item.commission_id ) {
        return this._('COM')
      }
      return item.product_id
    },
    name () {
      const item = this.item
      if (item.discount_id) {
        return this._('Discount') + ': (' + item.product_name + ')'
      }
      if (item.commission_id ) {
        return this._('Commission') + ': (' + item.product_name + ')'
      }
      return item.product_name
    }
  },
  methods: {
    reservationClicked(reservation) {
      this.$emit('reservationClicked', reservation)
    },
    resourceClicked(resource) {
      this.$emit('resourceClicked', resource)
    },
    seatClicked(seat) {
      this.$emit('seatClicked', seat)
    },
    valuecardClicked(valuecard) {
      this.$emit('valuecardClicked', valuecard)
    }
  }
}